<template>
  <div class="qrcode-container" ref="qrcode"></div>
</template>

<script>
import QRCode from 'qrcodejs2'
import outputUtils from '../../util/outputUtils'
export default {
  name: 'QrcodeContainer',
  props: {
    text: {
      type: String,
      required: true
    },
    width: Number,
    height: Number
  },
  data () {
    return {
      qrcode: null
    }
  },
  methods: {
    initQrcode () {
      let qrcode = this.$refs['qrcode']
      if (qrcode) {
        this.qrcode = new QRCode(qrcode, {
          width: typeof this.width === 'number' ? this.width : qrcode.clientWidth,
          height: typeof this.height === 'number' ? this.height : qrcode.clientHeight,
          text: this.text
        })
      }
    },
    destroyQrcode () {
      if (this.qrcode) {
        this.qrcode.clear()
      }
    },
    downloadImage (filename) {
      return new Promise((resolve, reject) => {
        let image = this.$el.querySelector('img')
        if (image) {
          let canvas = document.createElement('canvas')
          if (typeof this.width === 'number') {
            canvas.width = this.width
          } else {
            canvas.width = image.clientWidth
          }
          if (typeof this.height === 'number') {
            canvas.height = this.height
          } else {
            canvas.height = image.clientHeight
          }
          let context = canvas.getContext('2d')
          if (context) {
            context.drawImage(image, 0, 0)
            outputUtils.downloadUrl(canvas.toDataURL('image/png'), filename, true)
            resolve()
          } else {
            reject(new Error('二维码不支持下载'))
          }
        } else {
          reject(new Error('图片源不存在'))
        }
      })
    }
  },
  mounted () {
    this.initQrcode()
  },
  destroyed () {
    this.destroyQrcode()
  },
  watch: {
    text: function (val) {
      if (this.qrcode) {
        this.qrcode.makeCode(val)
      }
    }
  }
}
</script>

<style lang="scss">
  .qrcode-container {
    img,
    canvas {
      width: 100%;
      height: 100%;
    }
  }
</style>
